import axiosClient from '../axiosClient';

const closedDaysService = {
  async fetchAll(filters = {}) {
    const response = await axiosClient.get('/closed-days', {
      params: filters,
    });
    return response.data;
  },

  async export(filters = {}) {
    const response = await axiosClient.get('/closed-days/export', {
      params: filters,
      responseType: 'blob',
    });
    return response;
  },
};

export default closedDaysService;
